/**
 * Returns true if the given customer is a company, false otherwise.
 * A company is considered a facility if the facility field in the customer object is true.
 * @param {Object} customer - The customer object
 * @returns {boolean} True if the customer is a company, false otherwise
 */
export const facilityCompany = (customer) => {
if(customer?.facility) return false
return true
 
}
/**
 * Returns true if the user is a client of the given facility, false otherwise.
 * A user is considered a client of the facility if they are a contractor of the facility or if the facility is not a facility.
 * @param {Object} client - The client object
 * @param {Object} user - The user object
 * @returns {boolean} - True if the user is a client of the facility, false otherwise
 */
export const facilityClient = (client, user) => {
    //console.log("IN CONSOLE FACILITYCLIENT:", client, user)
    const userCustomerId = user?.customer?._ref
    const isContractor = client?.contractors?.some?.((x)=>x?._ref == userCustomerId)
    if(isContractor) return true
    //if(user?.userType == "Tecnico" && client?.facility) return true
    if(client?.facility) return false

    //if(client?.facility) return false

    return true
   }
/**
 * Returns true if the user is not a client, false otherwise.
 * @param {Object} user - The user object
 * @returns {boolean} - True if the user is not a client, false otherwise
 */
export const clientUser = (user) => {
    if(user?.userType == "Cliente") return false

return true
   }
/**
 * Returns true if the user is not a technician, false otherwise.
 * @param {Object} user - The user object
 * @returns {boolean} - True if the user is not a technician, false otherwise
 */
export const technician = (user) => {
    if(user?.userType == "Tecnico") return false

return true
   }

/**
 * Checks if the user is in God Mode
 * @param {Object} user - The user object
 * @returns {boolean} - True if the user is in God Mode, false otherwise
 */
export const isGodMode = (user) => {
    if(user?.userType == "God Mode") return true

return false
   }

/**
 * Checks if the user is an admin
 * @param {Object} user - The user object
 * @returns {boolean} - True if the user is an admin, false otherwise
 */
export const isAdmin = (user) => {
    if(user?.userType == "Admin") return true

        return false
   }

/**
 * Checks if the user is a super admin
 * @param {Object} user - The user object
 * @returns {boolean} - True if the user is a super admin, false otherwise
 */
   export const isSuperAdmin = (user) => {
    if(user?.userType == "Super Admin") return true

        return false
   }